import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { reset } from '../redux/app';
import { resetCarpet } from '../redux/carpet';
import { resetUserData } from '../redux/member';
import { resetMoodData } from '../redux/mood';
import { resetSignupData } from '../redux/signup';
import { resetSignupQuestions } from '../redux/signupQuestions';
import account from '../services/accountService';
import { RootState } from '../redux/store';
import { useHistory } from 'react-router-dom';
import { ONBORADING_SCREEN } from '../navigation/Constants';
import { deleteMemberPushToken } from '../services/memberService';

const BlockedAccount = (props: any) => {
    const dispatch = useDispatch();
    const history = useHistory();
    const { hubConnection } = useSelector((state: RootState) => state.app);
    const member = useSelector((state: RootState) => state.member);

    const clearReduxStoreDate = () => {
        dispatch(resetUserData());
        dispatch(resetMoodData());
        dispatch(reset());
        dispatch(resetSignupQuestions());
        dispatch(resetSignupData());
        dispatch(resetCarpet());

    };

    const logout = () => {
        if (window.platform === 'android' || window.platform === 'ios') {
            deleteMemberPushToken(member.memberCode);
        }
        account.logout();
        clearReduxStoreDate();
        hubConnection?.invoke("connectionClosed", props.member.memberCode);
        hubConnection?.stop();
        history.replace(ONBORADING_SCREEN);
    };

    if (!props.member.isBlockedAccount) return props.children
    else return (
        <div className="content_sec white wf-section" style={{ height: '100vh' }}>
            <div className="signup_top_info">
                <div className="signup_pict failure">
                    <img src="/assets/images/failure_pict.svg" />
                </div>
                <h2 className="signup_title welcome">החשבון נחסם</h2>
                <div>לבירור וביטול החסימה פנה למייל: shoshke@motke.co.il</div>
                <a href="#" className="edit_info_link red w-inline-block" onClick={logout}>
                    <div className="edit_link_info">
                        <h4 className="settink_link_title">התנתק</h4>
                    </div>
                </a>
            </div>
        </div>
    )
}

export default BlockedAccount;